import React from "react"
import Layout from "../layouts/sample";
import {ContactSectionFormTwoSpanish} from "../components/global/ContactSectionFormTwoSpanish";
import Seo from "../components/Seo";


const SpanishForm2 = () => {
  return (
    <Layout>
      <div className="container grant-form-container">
        <ContactSectionFormTwoSpanish className={"mb-md-80"}/>
      </div>
    </Layout>

  )
}

export default SpanishForm2

export const Head = () => <Seo title="Formulario de aplicacion para Rootstock Grant"/>;
